import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeatureName } from '@common/enums/feature-name.enum';
import { Specialist } from '@common/services/specialist/data/models/specialist.model';
import { pathsByFeatureName } from '@specialist/path-by-feature-name';
import { ConfigService } from '../config/config.service';

@Injectable()
export class NavigationService {
  constructor(private readonly router: Router, private configService: ConfigService) {}

  async navigateToErrorPage(queryParams: { [key: string]: unknown }): Promise<void> {
    await this.router.navigate(['/error-page'], { queryParams });
  }

  async navigateToMainForUserPage(specialist: Specialist): Promise<void> {
    const { DefaultRoute } = this.configService.routeSettings;

    if (!specialist?.id) {
      await this.router.navigate(['/specialist/select-skills'], { replaceUrl: true });
    } else if (specialist.isAdmin) {
      //TODO: move to back settings;
      const defaultAdminPage = '/specialist/specialists';
      await this.router.navigate([defaultAdminPage], { replaceUrl: true });
    } else {
      await this.router.navigate([pathsByFeatureName[DefaultRoute]], { replaceUrl: true });
    }
  }

  public async navigateByAvailableFeatures(
    isVideoChatFeatureAvailable: boolean,
    isLiveChatFeatureAvailable: boolean,
  ): Promise<void> {
    if (!isVideoChatFeatureAvailable && !isLiveChatFeatureAvailable) {
      return;
    } else if (isLiveChatFeatureAvailable) {
      await this.router.navigate([pathsByFeatureName[FeatureName.LiveChat]], { replaceUrl: true });
    } else if (isVideoChatFeatureAvailable) {
      await this.router.navigate([pathsByFeatureName[FeatureName.VideoChat]], { replaceUrl: true });
    }
  }

  isLiveChatPageActive(): boolean {
    return this.router.url.endsWith('specialist/live-chat') || this.router.url.includes('/specialist/specialists/');
  }

  isIncognitoPageActive(): boolean {
    return this.router.url.includes('/specialist/specialists/') && Boolean(this.router.url.split('/')[3]);
  }

  navigateToSpecialistsPage(): Promise<boolean> {
    return this.router.navigateByUrl(`/specialist/specialists`);
  }
}
